export const CALENDAR_ROLE_KEYS = {
    RESPONSABLE: "RESPONSABLE",
    MANAGER: "MANAGER",
    LEARNER: "LEARNER",
};

export const CALENDAR_ROLE_VIEWS = {
    PLANNED_EVENTS: "PLANNED_EVENTS",
    MY_EVENTS: "MY_EVENTS",
    TEAM_EVENTS: "TEAM_EVENTS",
};

const getRoleCode = (role) => String(role?.code || "").trim().toUpperCase();

export const getCalendarRoleConfig = (currentRole) => {
    const roleCode = getRoleCode(currentRole);
    const roleKey = roleCode === "TRAINING_RESPONSABLE"
        ? CALENDAR_ROLE_KEYS.RESPONSABLE
        : roleCode === "TRAINING_MANAGER"
            ? CALENDAR_ROLE_KEYS.MANAGER
            : CALENDAR_ROLE_KEYS.LEARNER;

    return {
        roleKey,
        roleCode,
        currentRole,
        isRh: roleKey === CALENDAR_ROLE_KEYS.RESPONSABLE,
        isManager: roleKey === CALENDAR_ROLE_KEYS.MANAGER,
        isCollaborator: roleKey === CALENDAR_ROLE_KEYS.LEARNER,
        canCreate: roleKey === CALENDAR_ROLE_KEYS.RESPONSABLE,
        canEdit: roleKey === CALENDAR_ROLE_KEYS.RESPONSABLE,
        canReplanify: roleKey === CALENDAR_ROLE_KEYS.RESPONSABLE,
        canCancel: roleKey === CALENDAR_ROLE_KEYS.RESPONSABLE,
        canAssign: roleKey === CALENDAR_ROLE_KEYS.RESPONSABLE,
        canSendInvitations: roleKey === CALENDAR_ROLE_KEYS.RESPONSABLE,
        canDownloadAttendanceSheet: roleKey === CALENDAR_ROLE_KEYS.RESPONSABLE,
        canManageAllEvents: roleKey === CALENDAR_ROLE_KEYS.RESPONSABLE,
        canSeeTeamFilter: roleKey === CALENDAR_ROLE_KEYS.MANAGER,
        canSelfRegister: roleKey === CALENDAR_ROLE_KEYS.LEARNER,
        viewOptions:
            roleKey === CALENDAR_ROLE_KEYS.LEARNER
                ? [
                    { value: CALENDAR_ROLE_VIEWS.PLANNED_EVENTS, label: "Sessions planifiées" },
                    { value: CALENDAR_ROLE_VIEWS.MY_EVENTS, label: "Mes événements" },
                ]
                : roleKey === CALENDAR_ROLE_KEYS.MANAGER
                    ? [
                        { value: CALENDAR_ROLE_VIEWS.PLANNED_EVENTS, label: "Événements planifiés" },
                        { value: CALENDAR_ROLE_VIEWS.TEAM_EVENTS, label: "Événements équipe" },
                    ]
                    : [],
        defaultView:
            roleKey === CALENDAR_ROLE_KEYS.LEARNER || roleKey === CALENDAR_ROLE_KEYS.MANAGER
                ? CALENDAR_ROLE_VIEWS.PLANNED_EVENTS
                : null,
        bannerLabel:
            roleKey === CALENDAR_ROLE_KEYS.RESPONSABLE
                ? "Vue responsable"
                : roleKey === CALENDAR_ROLE_KEYS.MANAGER
                    ? "Vue manager"
                    : "Vue apprenant",
    };
};
